import { render, staticRenderFns } from "./BuatList.vue?vue&type=template&id=200ac748&"
import script from "./BuatList.vue?vue&type=script&lang=js&"
export * from "./BuatList.vue?vue&type=script&lang=js&"
import style0 from "./BuatList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports